module.exports = __webpack_public_path__ + "static/media/12.9b11b9ef.jpg";